import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function UserPlanHistory() {

const location = useLocation();
const navigate = useNavigate();

const { userId, userName } = location.state || {};

const [planList, setPlanList] = useState([]);
const [loading, setLoading] = useState(false);
      const [fromDate, setFromDate] = useState('');
const [toDate, setToDate] = useState('');


const fetchUerPlanHis = async () => {
    setLoading(true);

    try {
        const response = await fetch(
            `https://api.tradeintell.com/get-plan-history/${userId}`
        );

        if(response.status == 200){
        const data = await response.json();
console.log(data);
        setPlanList(data);
        }
    } catch (err) {
        console.log(err);
    }

    setLoading(false);
};

useEffect(() => {
    if (userId) {
        fetchUerPlanHis();
    }
}, [userId]);


  const filteredPlanList = planList.filter((item) => {
  const buyDate = new Date(item.buy_on).toISOString().split("T")[0];

  if (fromDate && buyDate < fromDate) return false;
  if (toDate && buyDate > toDate) return false;

  return true;
});

const totalAmount = filteredPlanList.reduce(
  (sum, item) => sum + Number(item.pay_amount || 0),
  0
);

const latestPlan = filteredPlanList.length > 0 ? filteredPlanList[0] : null;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  };   

const getValidTill = (buyOn, duration) => {
  const date = new Date(buyOn);
  date.setDate(date.getDate() + Number(duration));

  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

const getValidTillDate = (buyOn, duration) => {
  const date = new Date(buyOn);
  date.setDate(date.getDate() + Number(duration));
  return date; // Returns a Date object
};


const isPlanActive = (buyOn, duration) => {
  const validTill = getValidTillDate(buyOn, duration);
  const today = new Date();

  today.setHours(0, 0, 0, 0);
  validTill.setHours(0, 0, 0, 0);

  return validTill >= today;
};


const renewalDate = latestPlan
  ? getValidTillDate(latestPlan.buy_on, latestPlan.duration)
  : null;

const isActive = renewalDate
  ? renewalDate >= new Date(new Date().setHours(0, 0, 0, 0))
  : false;


  return (
  <>
      <section className='my-4'>
        <div className='px-4'>

   <p className='page-heading'>{userName}'s Subscription History</p>
          <p className='para-text text-muted'>Track all subscriptions and payment records in one place.
          </p>

        <div className='d-flex flex-wrap'>
    <p
  className={`px-3 py-1 mt-2 mb-1 align-content-center rounded-pill bg-secondary text-light cursor-pointer para-text`}
  onClick={() => navigate(-1)}
>
  Go Back
</p>

<input
  type="date"
  className="my-2 form-control para-text mx-2"
  style={{maxWidth:'180px'}}
  value={fromDate}
  onChange={(e)=>setFromDate(e.target.value)}
/>

<input
  type="date"
  className="my-2 form-control para-text"
  style={{maxWidth:'180px'}}
  value={toDate}
  onChange={(e)=>setToDate(e.target.value)}
/>
</div>



<div className='row mt-2'>

  <div className='col-lg-3 col-md-6 col-12 my-2'>
    <div className='subs-card'>
      <p className='fs-4'>
        <span className='subs-num'>{filteredPlanList.length}</span>
      </p>
      <p className='mb-0 fw-semibold text-danger'>No of Plans </p>
      <span className='para-text text-muted fw-semibold'>Purchased</span>
    </div>
  </div>

  <div className='col-lg-3 col-md-6 col-12 my-2'>
    <div className='subs-card'>
      <p className='fs-4'>
        <span className='subs-num'>₹ {totalAmount}</span>
      </p>
      <p className='mb-0 fw-semibold text-primary'>Total Amount </p>
      <span className='para-text text-muted fw-semibold'>Paid</span>
    </div>
  </div>

  <div className='col-lg-3 col-md-6 col-12 my-2'>
    <div className='subs-card'>
      <p className='fs-4'>
        <span className='subs-num'>
          {latestPlan?.plan_name || "-"}
        </span>
      </p>
  <p
  className={`mb-0 fw-semibold ${
    latestPlan && isPlanActive(latestPlan.buy_on, latestPlan.duration)
      ? "text-success"
      : "text-danger"
  }`}
>
  {latestPlan
    ? isPlanActive(latestPlan.buy_on, latestPlan.duration)
      ? "Current Plan"
      : "Expired"
    : "-"}
</p>

      <span className='para-text text-muted fw-semibold'>Valid till {getValidTill(latestPlan?.buy_on, latestPlan?.duration)}</span>

    </div>
  </div>


<div className='col-lg-3 col-md-6 col-12 my-2'>
  <div className='subs-card'>
    <p className='fs-4'>
      <span className='subs-num'>
        {renewalDate ? formatDate(renewalDate) : "-"}
      </span>
    </p>

    <p className='mb-0 fw-semibold text-warning'>
      Renewal Due
    </p>

    <span
      className={`para-text text-muted fw-semibold`}
    >
      {isActive ? "Active Plan" : "Expired"}
    </span>
  </div>
</div>

</div>

      <div className='table-responsive mt-3'>
    <table className='table w-100 channel-table'>

        <thead className='channel-head'>
            <tr>
                <th>S No</th>
                <th>Plan Name</th>
                <th>Buy On</th>
                <th>Valid Till</th>
                  <th>Amount</th>
                <th>Payment Id</th>
                <th>Pay Status</th>
            </tr>
        </thead>

<tbody className="para-text">
    {loading ? (
        <tr>
            <td colSpan="6" className="text-center">
                Loading...
            </td>
        </tr>
    ) : filteredPlanList.length > 0 ? (
        filteredPlanList.map((item, index) => (
            <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{item.plan_name}<br /><span className="para-text text-muted fw-semibold">{item.plan_code}</span></td>
                <td>{formatDate(item.buy_on)}</td>
                <td>{getValidTill(item.buy_on, item.duration)}</td>
                <td>₹ {item.pay_amount}</td>
                <td>{item.pay_id}</td>
                <td>
                   {item.pay_status}
                </td>
            </tr>
        ))
    ) : (
        <tr>
            <td colSpan="7" className="text-center">
                No Subscription Plan History Found.
            </td>
        </tr>
    )}
</tbody>
</table>
</div>

</div>
</section>
  </>
  )
}

export default UserPlanHistory
